import React, { useState } from "react"
import { union, uniqBy, map } from "lodash"
import Chip from "@material-ui/core/Chip"
import Autocomplete from "@material-ui/lab/Autocomplete"
import { makeStyles } from "@material-ui/core/styles"
import TextField from "@material-ui/core/TextField"

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(3),
    },
    chip: {
      textTransform: "capitalize",
    },
  },
}))

const CollectionsInput = props => {
  const classes = useStyles()
  const { dataOptions, listOptions } = props
  // eslint-disable-next-line no-unused-vars
  const [disabledIndex, setDisabledIndex] = useState(dataOptions)

  const valueOptions = listOptions.filter(function(item) {
    for (var key in dataOptions) {
      if (item.id === undefined || item.id === dataOptions[key]) return true
    }
    return false
  })

  // const valueOptions = map(dataOptions, item => {
  //   return { id: item, name: item }
  // })
  const newData = union(valueOptions, listOptions)
  const listData = map(newData, item => {
    return item
  })
  const onChangeChip = (e, v) => {
    const valueOptions1 = map(v, item => {
      return item.id
    })
    props.updateField(props.input.name, valueOptions1)
  }
  return (
    <div className={classes.root}>
      <Autocomplete
        multiple
        disableClearable
        id="select-variant-standard"
        options={uniqBy(listData, "id")}
        value={valueOptions}
        onChange={onChangeChip}
        filterSelectedOptions={true}
        getOptionLabel={option => option.name}
        style={{ width: "100%" }}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => {
            return (
              <Chip
                label={option.name}
                {...getTagProps({ index })}
                color="primary"
                style={{ color: "#FFFFFF" }}
              />
            )
          })
        }
        renderInput={params => (
          <TextField
            fullWidth
            {...params}
            variant="standard"
            label=""
            placeholder=""
          />
        )}
      />
    </div>
  )
}

export default CollectionsInput
